export const OpportunityBanner = () => (
  <section className="py-16 md:py-20 bg-gradient-to-r from-gray-900 via-[#1e3a8a] to-gray-900 relative overflow-hidden">
    <div className="absolute inset-0 opacity-10">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent shimmer-bg"></div>
    </div>
    <div className="container mx-auto px-6 relative z-10">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
          There are 1.2 million Indians in ANZ actively searching for the brands they grew up with.
        </h2>
        <p className="text-2xl md:text-4xl text-white/80 mb-2">Nobody is serving them well.</p>
        <p className="text-2xl md:text-4xl font-bold bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent">
          Until now.
        </p>
      </div>
    </div>
  </section>
);
